import type React from 'react'
import { PointerSensor } from '@dnd-kit/core'

/**
 * Ob aus diesem Druck ein Zug werden darf.
 *
 * **Die offene Zeile ist hier kein Thema** — die Zeile im Bearbeiten-Modus
 * schaltet ihren Sortable selbst ab (`useSortable({ disabled: editing })`),
 * genau wie eine aufgeklappte **Aufgabe** in der Liste
 * (`SortableTaskEntry`). Bleibt der Löschknopf: Er ist ein Griff für sich, und
 * ein Wischen darauf soll die Zeile nicht mitnehmen.
 */
export function mayStartDrag(event: PointerEvent): boolean {
  if (!event.isPrimary || event.button !== 0) return false
  const target = event.target as HTMLElement | null
  if (!target) return false
  return !target.closest('button')
}

/** Zieht Checklisten-Zeilen, lässt Knöpfe in Ruhe. */
export class RowPointerSensor extends PointerSensor {
  static activators = [{
    eventName: 'onPointerDown' as const,
    handler: ({ nativeEvent: event }: React.PointerEvent) => mayStartDrag(event),
  }]
}
